import React from 'react';
import { string } from 'prop-types';

/**
 * @typedef {Object} ChevronProps
 * @prop {string} [className]
 */

/** @type {React.FunctionComponent<ChevronProps>} */
const Chevron = ({ className }) => (
  <div className={className} aria-hidden>
    <svg xmlns="http://www.w3.org/2000/svg" width="6" height="8">
      <path fill="none" stroke="#666" d="M1 0l4 4-4 4" />
    </svg>
  </div>
);

Chevron.propTypes = {
  className: string,
};

export default Chevron;
